// Get random colors for bottom half of stacked bar chart
// 0 is bottom, 1 is top
export const getColorsByStackHalf = (halfIndex, count) => {
  const colors = [
    '#9f577f',
    '#58c85c',
    '#9962db',
    '#65a934',
    '#a83daa',
    '#aeba36',
    '#5e76e5',
    '#dc9e36',
    '#6b55ae',
    '#5abd7d',
    '#e171d4',
    '#367e3d',
    '#e54280',
    '#55c9ae',
    '#dc4550',
    '#4cbad5',
    '#d65e2c',
    '#5b85c7',
    '#647c20',
    '#c4438f',
    '#95b169',
    '#8e5b9a',
    '#b29f48',
    '#c392db',
    '#6e6c2d',
    '#b43a5b',
    '#398c6f',
    '#e485a0',
    '#99652d',
    '#9a4b5b',
    '#e0966d',
    '#ae503b'
  ];

  if (halfIndex === 1) {
    return '#394149';
  }

  return colors.splice(0, count);
};
